/* eslint-disable complexity */
import {
    ADD_CARD,
    ADD_CARD_IN_COLUMN,
    CLEAR_STATE,
    CREATE_COLUMN,
    DUPLICATE_CARD,
    MARK_AS_SYNCED,
    MARK_CARD_WITH_ERROR,
    MOVE_CARD,
    RECEIVE_CARDS,
    REMOVE_CARD,
    REMOVE_CARD_FROM_COLUMN,
    REPLACE_CARD,
    SET_FILTERS,
    SET_LOGGED_USER,
    SET_SEARCH,
    UPDATE_CARD,
    UPDATE_IS_DRAGGING,
    CHANGE_COLUMN,
} from '../actions/actions';


import {
    addCard,
    moveCard,
    changeColumn,
    createColumn,
    updateCard,
    removeCard,
    removeCardFromColumn,
    receiveCards,
    replaceCard,
    markAsSynced,
    clearCards,
    setFilters,
    setSearch,
    setLoggedUser,
    markCardWithError,
    duplicateCard,
    updateIsDragging,
    addCardInColumn,
} from './card_reducers';


function workflowReducers(state, action) {
    let newState = {};

    switch (action.type) {
    case ADD_CARD: newState = addCard(state, action); break;
    case ADD_CARD_IN_COLUMN: newState = addCardInColumn(state, action); break;
    case MOVE_CARD: newState = moveCard(state, action); break;
    case CHANGE_COLUMN: newState = changeColumn(state, action); break;
    case CREATE_COLUMN: newState = createColumn(state, action); break;
    case UPDATE_CARD: newState = updateCard(state, action); break;
    case REMOVE_CARD: newState = removeCard(state, action); break;
    case REMOVE_CARD_FROM_COLUMN: newState = removeCardFromColumn(state, action); break;
    case RECEIVE_CARDS: newState = receiveCards(state, action); break;
    case REPLACE_CARD: newState = replaceCard(state, action); break;
    case MARK_AS_SYNCED: newState = markAsSynced(state, action); break;
    case CLEAR_STATE: newState = clearCards(state, action); break;
    case SET_FILTERS: newState = setFilters(state, action); break;
    case SET_SEARCH: newState = setSearch(state, action); break;
    case SET_LOGGED_USER: newState = setLoggedUser(state, action); break;
    case MARK_CARD_WITH_ERROR: newState = markCardWithError(state, action); break;
    case DUPLICATE_CARD: newState = duplicateCard(state, action); break;
    case UPDATE_IS_DRAGGING: newState = updateIsDragging(state, action); break;

    default:
        newState = Object.assign({}, state);
    }

    return newState;
}


export default workflowReducers;
